import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
import { BookOpenIcon, ClipboardListIcon, HeartIcon, MoonIcon, SparklesIcon, WalletIcon, ZapIcon, MessageCircleIcon, AlertTriangleIcon, FrownIcon, PiggyBankIcon, TrendingDownIcon, CheckCircleIcon, DownloadIcon, GiftIcon } from 'lucide-react';
export function SalesPage() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleAddToCart = () => {
    // Track AddToCart event with Meta Pixel (additional tracking on button click)
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'De Quincena en Rojo a Quincena en Verde',
        content_type: 'product',
        value: 7.97,
        currency: 'USD'
      });
      console.log('✅ Meta Pixel: AddToCart event tracked (button click)');
    } else {
      console.error('❌ Meta Pixel not loaded - fbq is not available');
    }
    // Open checkout page
    window.open('https://levoradigital.com/cart/46411164352689:1', '_blank');
  };
  return <div className="flex flex-col items-center w-full min-h-screen bg-cream-50 text-gray-800 font-sans" data-id="element-11">
      {/* Persuasive Header */}
      <header className="w-full bg-[#166534] py-3 px-4" data-id="element-12">
        <div className="max-w-6xl mx-auto text-center" data-id="element-13">
          <p className="text-white text-sm md:text-base font-medium" data-id="element-14">
            🔥 Descarga Inmediata - Oferta Especial solo por lanzamiento
          </p>
        </div>
      </header>
      {/* Hero Section */}
      <section className="w-full max-w-4xl mx-auto px-4 py-8 md:py-10" data-id="element-15">
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-16">
          <div className="flex-1" data-id="element-17">
            <h1 className="text-3xl md:text-4xl font-bold text-green-800 mb-4" data-id="element-18">
              ¿Por qué sigues llegando sin dinero… aunque trabajas duro cada
              quincena?
            </h1>
            <p className="text-lg mb-6" data-id="element-19">
              Si estás leyendo esto, es porque estás cansada.
            </p>
            <p className="text-lg mb-6" data-id="element-20">
              Cansada de esforzarte tanto… para volver a vivir la misma historia
              cada quincena:
            </p>
            <p className="text-lg font-semibold mb-6 text-red-700" data-id="element-21">
              sin dinero
              <br data-id="element-22" />
              sin claridad
              <br data-id="element-23" />
              sin entender en qué se fue
            </p>
            <p className="text-lg mb-6" data-id="element-24">
              y repitiéndote: "ahora sí me voy a organizar"
            </p>
            <p className="text-lg mb-6" data-id="element-25">
              Pero llega otra quincena… y nada cambia.
            </p>
            <p className="text-lg mb-6" data-id="element-26">Y vuelve esa pregunta dolorosa:</p>
            <p className="text-lg font-semibold mb-6 italic" data-id="element-27">
              "¿Qué estoy haciendo mal?"
            </p>
          </div>
          <div className="flex-1 flex justify-center" data-id="element-28">
            <div className="flex flex-col items-center" data-id="element-29">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iTCy8aCM9rHEaVr6eH6PxB/451d57e3-e835-4d16-86d2-ed16e8fdb89d.png" alt="De Quincena en Rojo a Quincena en Verde" className="w-full max-w-xs shadow-lg transform hover:rotate-2 transition-transform duration-300" data-id="element-30" />
              <button onClick={scrollToPricing} className="mt-6 bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all duration-300" data-id="element-31">
                Descubre Cómo
              </button>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-10 max-w-2xl mx-auto" data-id="element-32">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-6" data-id="element-33">
            La verdad es dura, pero también liberadora:
          </h2>
          <p className="text-xl font-bold mb-6" data-id="element-34">
            NO eres tú. NO es tu salario. NO es tu disciplina. Es que te falta
            un sistema.
          </p>
          <p className="text-lg mb-8" data-id="element-35">
            Un sistema simple. Visual. Hecho para mujeres LATINAS. Un sistema
            que por fin te ayude a controlar tu dinero… y no que tu dinero te
            controle a ti.
          </p>
        </div>
      </section>
      {/* Problem Section */}
      <section className="w-full bg-red-50 py-8" data-id="element-36">
        <div className="max-w-5xl mx-auto px-4" data-id="element-37">
          <h2 className="text-2xl md:text-3xl font-bold text-red-800 mb-4 text-center" data-id="element-38">
            La verdad incómoda que nadie te dice
          </h2>
          <p className="text-lg mb-3 text-center text-gray-700" data-id="element-39">
            No es que gastes de más. No es que seas mala administrando. No es
            que seas desordenada.
          </p>
          <p className="text-lg mb-3 text-center text-gray-700" data-id="element-40">
            Lo que pasa es que estás sobreviviendo sin un mapa.
          </p>
          <p className="text-lg mb-8 text-center text-gray-700 font-medium" data-id="element-41">
            Estás cruzando tu vida financiera con los ojos vendados.
          </p>
          <p className="text-xl font-semibold mb-6 text-center text-red-800" data-id="element-42">
            Y eso te deja atrapada en:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6" data-id="element-43">
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-44">
              <div className="flex flex-col items-center text-center" data-id="element-45">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-46">
                  <ZapIcon className="w-8 h-8 text-red-600" data-id="element-47" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-48">
                  Estrés constante
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-49">
                  Viviendo con ansiedad financiera cada día
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-50">
              <div className="flex flex-col items-center text-center" data-id="element-51">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-52">
                  <MessageCircleIcon className="w-8 h-8 text-red-600" data-id="element-53" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-54">
                  Discusiones por dinero
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-55">
                  Conflictos constantes que dañan tus relaciones
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-56">
              <div className="flex flex-col items-center text-center" data-id="element-57">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-58">
                  <AlertTriangleIcon className="w-8 h-8 text-red-600" data-id="element-59" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-60">
                  Miedo a emergencias
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-61">
                  Sin colchón financiero para imprevistos
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-62">
              <div className="flex flex-col items-center text-center" data-id="element-63">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-64">
                  <FrownIcon className="w-8 h-8 text-red-600" data-id="element-65" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-66">
                  Sentimiento de fracaso
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-67">
                  Sintiéndote incapaz de controlar tu dinero
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-68">
              <div className="flex flex-col items-center text-center" data-id="element-69">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-70">
                  <PiggyBankIcon className="w-8 h-8 text-red-600" data-id="element-71" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-72">
                  Cero ahorro
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-73">
                  Sin poder guardar ni un peso para el futuro
                </p>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-74">
              <div className="flex flex-col items-center text-center" data-id="element-75">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4" data-id="element-76">
                  <TrendingDownIcon className="w-8 h-8 text-red-600" data-id="element-77" />
                </div>
                <h3 className="text-lg font-bold text-red-800 mb-2" data-id="element-78">
                  "Nunca avanzo"
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-79">
                  Esa dolorosa sensación de estar estancada
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-md text-center max-w-2xl mx-auto" data-id="element-80">
            <p className="text-xl font-semibold text-gray-800" data-id="element-81">
              Eso pesa. Eso duele. Pero también se puede cambiar.
            </p>
          </div>
        </div>
      </section>
      {/* Solution Section */}
      <section className="w-full bg-green-50 py-8" data-id="element-82">
        <div className="max-w-5xl mx-auto px-4" data-id="element-83">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-4 text-center" data-id="element-84">
            Imagina esto por un momento…
          </h2>
          <p className="text-lg mb-12 text-center text-gray-600 max-w-3xl mx-auto" data-id="element-85">
            El día que te pagan, haces algo distinto. En vez de gastar "como va
            saliendo", organizas tu dinero con un sistema visual que transforma
            tu vida financiera.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-86">
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-87">
              <div className="flex items-start gap-4" data-id="element-88">
                <div className="flex-shrink-0" data-id="element-89">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-90">
                    <WalletIcon className="w-6 h-6 text-green-600" data-id="element-91" />
                  </div>
                </div>
                <div data-id="element-92">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-93">
                    Separa tu dinero en sobres
                  </h3>
                  <p className="text-gray-600" data-id="element-94">
                    Renta y servicios, mercado, transporte, tiendita,
                    emergencias y ahorro. Cada peso tiene un nombre y un lugar
                    específico.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-95">
              <div className="flex items-start gap-4" data-id="element-96">
                <div className="flex-shrink-0" data-id="element-97">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-98">
                    <ClipboardListIcon className="w-6 h-6 text-green-600" data-id="element-99" />
                  </div>
                </div>
                <div data-id="element-100">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-101">
                    Control total de tus gastos
                  </h3>
                  <p className="text-gray-600" data-id="element-102">
                    Sistema visual que te permite ver exactamente cuánto tienes
                    para cada categoría. Sin apps complicadas, sin estrés.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-103">
              <div className="flex items-start gap-4" data-id="element-104">
                <div className="flex-shrink-0" data-id="element-105">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-106">
                    <HeartIcon className="w-6 h-6 text-green-600" data-id="element-107" />
                  </div>
                </div>
                <div data-id="element-108">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-109">
                    Gustitos sin culpa
                  </h3>
                  <p className="text-gray-600" data-id="element-110">
                    Tu sobre favorito: dinero destinado para darte gustos sin
                    sentirte mal. Porque mereces disfrutar tu dinero también.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-111">
              <div className="flex items-start gap-4" data-id="element-112">
                <div className="flex-shrink-0" data-id="element-113">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-114">
                    <SparklesIcon className="w-6 h-6 text-green-600" data-id="element-115" />
                  </div>
                </div>
                <div data-id="element-116">
                  <h3 className="text-xl font-bold text-green-800 mb-2" data-id="element-117">
                    Llega con dinero sobrando
                  </h3>
                  <p className="text-gray-600" data-id="element-118">
                    Por primera vez en tu vida, llegas a la siguiente quincena
                    con dinero disponible. Ese día recuperas tu paz financiera.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-xl p-8 text-white text-center" data-id="element-119">
            <p className="text-xl md:text-2xl font-bold mb-3" data-id="element-120">
              Cada peso tiene un nombre. Cada peso tiene un lugar. Cada peso
              tiene una misión.
            </p>
            <p className="text-lg opacity-90" data-id="element-121">
              Ese día entiendes que nunca ganaste poco… solo te faltaba un
              método.
            </p>
          </div>
        </div>
      </section>
      {/* Method Section */}
      <section className="w-full py-8" data-id="element-122">
        <div className="max-w-4xl mx-auto px-4" data-id="element-123">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-700 mb-6 text-center" data-id="element-124">
            El método del sobre LATINO que cambia vidas
          </h2>
          <p className="text-lg mb-6" data-id="element-125">
            El "cash stuffing" se volvió tendencia en Estados Unidos… pero así
            como está, no funciona en LATAM.
          </p>
          <p className="text-lg mb-6" data-id="element-126">¿Por qué?</p>
          <p className="text-lg mb-6" data-id="element-127">Porque la vida aquí es distinta.</p>
          <p className="text-lg mb-8" data-id="element-128">
            Aquí existe la tiendita. Aquí se paga en efectivo. Aquí los
            antojitos importan. Aquí el transporte cambia cada semana. Aquí las
            pequeñas fugas arruinan meses completos.
          </p>
          <p className="text-lg mb-6" data-id="element-129">Por eso nació este sistema:</p>
          <div className="bg-green-100 border-l-4 border-green-600 p-6 rounded-r-lg mb-8" data-id="element-130">
            <p className="text-xl font-bold text-green-800 mb-2" data-id="element-131">
              El Método del Sobre Latino
            </p>
            <p className="text-lg text-green-700" data-id="element-132">
              (adaptado totalmente a la vida real de las mujeres de LATAM)
            </p>
            <p className="mt-4" data-id="element-133">
              Es visual. Es práctico. Es simple. Y funciona.
            </p>
          </div>
          <div className="bg-gradient-to-r from-green-700 to-green-600 text-white p-6 rounded-lg mb-6" data-id="element-134">
            <h3 className="text-xl font-bold mb-4" data-id="element-135">
              De Quincena en Rojo a Quincena en Verde
            </h3>
            <p className="mb-4" data-id="element-136">
              La guía práctica creada para mujeres latinas que quieren dejar de
              vivir "sin dinero" y empezar a ver verde en su billetera.
            </p>
          </div>
          <div className="flex justify-center" data-id="element-137">
            <button onClick={scrollToPricing} className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all duration-300" data-id="element-138">
              Descubre como
            </button>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="w-full bg-amber-50 py-8" data-id="element-139">
        <div className="max-w-5xl mx-auto px-4" data-id="element-140">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-800 mb-8 text-center" data-id="element-141">
            ¿Qué vas a aprender dentro?
          </h2>
          {/* Main Benefits Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-142">
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-143">
              <div className="flex gap-4" data-id="element-144">
                <div className="flex-shrink-0" data-id="element-145">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-146">
                    <BookOpenIcon className="w-6 h-6 text-green-700" data-id="element-147" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-148">
                  <div className="flex items-start gap-2 mb-2" data-id="element-149">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-150" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-151">
                      Explicaciones simples
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-152">
                    Sin tecnicismos financieros, todo explicado de forma clara y
                    práctica
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-153">
              <div className="flex gap-4" data-id="element-154">
                <div className="flex-shrink-0" data-id="element-155">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-156">
                    <WalletIcon className="w-6 h-6 text-green-700" data-id="element-157" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-158">
                  <div className="flex items-start gap-2 mb-2" data-id="element-159">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-160" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-161">
                      Método del Sobre versión LATAM
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-162">
                    Sistema adaptado a la realidad latina: tiendita, transporte
                    y gastos reales
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-163">
              <div className="flex gap-4" data-id="element-164">
                <div className="flex-shrink-0" data-id="element-165">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-166">
                    <ClipboardListIcon className="w-6 h-6 text-green-700" data-id="element-167" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-168">
                  <div className="flex items-start gap-2 mb-2" data-id="element-169">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-170" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-171">
                      Ejercicios prácticos paso a paso
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-172">
                    Actividades guiadas para implementar el método desde el día
                    1
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-173">
              <div className="flex gap-4" data-id="element-174">
                <div className="flex-shrink-0" data-id="element-175">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-176">
                    <DownloadIcon className="w-6 h-6 text-green-700" data-id="element-177" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-178">
                  <div className="flex items-start gap-2 mb-2" data-id="element-179">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-180" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-181">
                      Plantillas listas para imprimir
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-182">
                    Sobres, trackers y herramientas visuales que puedes usar de
                    inmediato
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-183">
              <div className="flex gap-4" data-id="element-184">
                <div className="flex-shrink-0" data-id="element-185">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-186">
                    <PiggyBankIcon className="w-6 h-6 text-green-700" data-id="element-187" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-188">
                  <div className="flex items-start gap-2 mb-2" data-id="element-189">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-190" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-191">
                      Reto de ahorro quincenal
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-192">
                    Desafío progresivo para construir tu colchón financiero sin
                    sufrimiento
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-193">
              <div className="flex gap-4" data-id="element-194">
                <div className="flex-shrink-0" data-id="element-195">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-196">
                    <ZapIcon className="w-6 h-6 text-green-700" data-id="element-197" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-198">
                  <div className="flex items-start gap-2 mb-2" data-id="element-199">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-200" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-201">
                      Elimina fugas invisibles
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-202">
                    Identifica y detén los gastos hormiga que te roban la
                    quincena
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-203">
              <div className="flex gap-4" data-id="element-204">
                <div className="flex-shrink-0" data-id="element-205">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-206">
                    <HeartIcon className="w-6 h-6 text-green-700" data-id="element-207" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-208">
                  <div className="flex items-start gap-2 mb-2" data-id="element-209">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-210" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-211">
                      Gustitos sin culpa
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-212">
                    Aprende a darte gustos planificados sin descontrolar tu
                    presupuesto
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-213">
              <div className="flex gap-4" data-id="element-214">
                <div className="flex-shrink-0" data-id="element-215">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-216">
                    <AlertTriangleIcon className="w-6 h-6 text-green-700" data-id="element-217" />
                  </div>
                </div>
                <div className="flex-1" data-id="element-218">
                  <div className="flex items-start gap-2 mb-2" data-id="element-219">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-220" />
                    <h3 className="text-lg font-bold text-gray-900" data-id="element-221">
                      Crea tu fondo de emergencia
                    </h3>
                  </div>
                  <p className="text-gray-600 text-sm" data-id="element-222">
                    Construye tu colchón financiero para imprevistos sin estrés
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Simple Checkmarks */}
          <div className="bg-white rounded-xl p-6 shadow-sm mb-8" data-id="element-223">
            <div className="space-y-3" data-id="element-224">
              <div className="flex items-center gap-3" data-id="element-225">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-226" />
                <span className="text-gray-700" data-id="element-227">
                  Formato digital - descarga inmediata
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-228">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-229" />
                <span className="text-gray-700" data-id="element-230">
                  Actualizado con las últimas estrategias financieras
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-231">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-232" />
                <span className="text-gray-700" data-id="element-233">
                  Acceso de por vida y actualizaciones gratuitas
                </span>
              </div>
            </div>
          </div>
          <h3 className="text-xl font-bold text-green-800 mb-4 text-center" data-id="element-234">
            Por qué funciona tan rápido
          </h3>
          <p className="text-lg mb-6" data-id="element-235">
            Porque no te pide hacer cosas imposibles.
          </p>
          <div className="bg-white rounded-xl p-6 shadow-sm mb-6" data-id="element-236">
            <div className="space-y-2 text-gray-700" data-id="element-237">
              <p data-id="element-238">❌ No te pide dejar antojitos.</p>
              <p data-id="element-239">❌ No te pide hacer dietas financieras.</p>
              <p data-id="element-240">❌ No te pide aprender contabilidad.</p>
              <p data-id="element-241">❌ No te pide revisar cada peso de memoria.</p>
            </div>
          </div>
          <p className="text-lg mb-4 font-medium text-green-800" data-id="element-242">
            Lo que te pide es algo muchísimo más simple:
          </p>
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-l-4 border-green-600 p-6 rounded-r-lg shadow-sm" data-id="element-243">
            <div className="space-y-2" data-id="element-244">
              <p className="flex items-start gap-2" data-id="element-245">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-246" />
                <span data-id="element-247">Separar tu dinero antes de gastarlo.</span>
              </p>
              <p className="flex items-start gap-2" data-id="element-248">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-249" />
                <span data-id="element-250">Darle un propósito a cada peso.</span>
              </p>
              <p className="flex items-start gap-2" data-id="element-251">
                <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-252" />
                <span data-id="element-253">
                  Seguir un sistema visual que no requiere esfuerzo mental.
                </span>
              </p>
            </div>
          </div>
          <p className="text-lg font-bold text-green-800 mt-6 text-center" data-id="element-254">
            Eso es todo. Y funciona.
          </p>
        </div>
      </section>
      {/* FAQ Section */}
      <section className="w-full py-6 bg-gray-50" data-id="element-255">
        <div className="max-w-4xl mx-auto px-4" data-id="element-256">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-8 text-center" data-id="element-257">
            Preguntas frecuentes
          </h2>
          <div className="space-y-6" data-id="element-258">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-259">
              <h3 className="text-xl font-bold mb-3 text-amber-700" data-id="element-260">
                ¿Es posible ahorrar desde la próxima quincena?
              </h3>
              <p data-id="element-261">Sí. Miles de mujeres ya lo están logrando con este método.</p>
              <p className="mt-2" data-id="element-262">Y tú puedes ser la siguiente.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-263">
              <h3 className="text-xl font-bold mb-3 text-amber-700" data-id="element-264">
                "Pero, ¿y si gano poco?"
              </h3>
              <p data-id="element-265">Ese es uno de los grandes mitos del dinero.</p>
              <p className="mt-3" data-id="element-266">La verdad es esta:</p>
              <p className="mt-3 font-medium" data-id="element-267">
                No importa cuánto ganes. Importa cómo organizas lo que recibes.
              </p>
              <p className="mt-3" data-id="element-268">Ganar más sin método = gastar más.</p>
              <p data-id="element-269">Ganar lo mismo con método = control total.</p>
            </div>
          </div>
          <div className="mt-8 bg-green-100 p-6 rounded-lg border-l-4 border-green-600" data-id="element-270">
            <p className="text-lg mb-4" data-id="element-271">
              Este ebook no es un gasto. Es una decisión que cambia tu vida
              financiera.
            </p>
            <p className="text-lg" data-id="element-272">
              Te acompaña cada quincena. Te da estructura. Te da claridad. Y,
              sobre todo… te devuelve la paz.
            </p>
          </div>
        </div>
      </section>
      {/* Testimonial/Story Section */}
      <section className="w-full py-8" data-id="element-273">
        <div className="max-w-4xl mx-auto px-4" data-id="element-274">
          <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-6" data-id="element-275">
            Mi historia (y por qué sé exactamente cómo te sientes)
          </h2>
          <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-276">
            <p className="mb-4" data-id="element-277">
              Hace unos años, cuando empecé a cobrar por quincena, vivía igual
              que tú: estresada, agobiada y con miedo de que no me alcanzara.
            </p>
            <p className="mb-4" data-id="element-278">
              Pero un día, después de una quincena especialmente dura, revisé
              mis cuentas y algo me rompió por dentro:
            </p>
            <div className="pl-4 border-l-4 border-red-500 my-6" data-id="element-279">
              <p className="mb-2 text-red-700" data-id="element-280">
                Gané bien… pero terminé con cero.
              </p>
              <p className="mb-2 text-red-700" data-id="element-281">No sabía en qué se me fue.</p>
              <p className="mb-2 text-red-700" data-id="element-282">Me sentía fracasada.</p>
              <p className="text-red-700" data-id="element-283">
                Sentí que había perdido el control de mi propia vida.
              </p>
            </div>
            <p className="mb-4" data-id="element-284">
              Esa noche lloré en silencio. No por el dinero. Sino por sentirme
              fuera de control.
            </p>
            <p className="mb-4" data-id="element-285">
              Busqué soluciones. Probé apps. Probé cursos. Probé métodos
              complicados. Nada funcionaba.
            </p>
            <p className="mb-4" data-id="element-286">
              Hasta que descubrí el "cash stuffing". Me encantó. Pero era
              demasiado gringo. No hablaba de tiendita, antojitos, transporte ni
              efectivo. No era mi realidad.
            </p>
            <p className="mb-4" data-id="element-287">
              Así que lo adapté. Lo hice simple. Lo hice visual. Lo hice latino.
            </p>
            <p className="mb-4" data-id="element-288">
              Y en la primera quincena… ahorré por primera vez en mi vida.
            </p>
            <p className="mb-4" data-id="element-289">
              Mis amigas lo pidieron. Mis primas también. Se volvió un método.
            </p>
            <p className="text-green-700 font-medium" data-id="element-290">
              Y ahora está aquí… convertido en un ebook que ya está ayudando a
              miles de mujeres a transformar su vida financiera.
            </p>
          </div>
        </div>
      </section>
      {/* Pricing/Purchase Section */}
      <section id="pricing-section" className="w-full py-10 bg-gradient-to-b from-white to-green-50" data-id="element-291">
        <div className="max-w-5xl mx-auto px-4" data-id="element-292">
          <div className="text-center mb-8" data-id="element-293">
            <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-4" data-id="element-294">
              Obtén tu guía completa hoy
            </h2>
            <p className="text-xl text-gray-700" data-id="element-295">
              Todo lo que necesitas para transformar tu vida financiera
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-4xl mx-auto" data-id="element-296">
            <div className="grid md:grid-cols-2 gap-0" data-id="element-297">
              {/* Product Image */}
              <div className="bg-gradient-to-br from-green-600 to-green-700 p-8 flex items-center justify-center" data-id="element-298">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uJzzoBvEB1D6rmLCyEYcJu/Mockup_Oferta.png" alt="De Quincena en Rojo a Quincena en Verde - Ebook" className="w-full max-w-md rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-299" />
              </div>
              {/* Pricing Details */}
              <div className="p-8 md:p-10 flex flex-col justify-center" data-id="element-300">
                <div className="mb-6" data-id="element-301">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-302">
                    De Quincena en Rojo a Quincena en Verde
                  </h3>
                  <p className="text-gray-600" data-id="element-303">
                    Tu guía práctica para el control financiero
                  </p>
                </div>
                <div className="mb-8" data-id="element-304">
                  <div className="flex items-baseline gap-2 mb-2" data-id="element-305">
                    <span className="text-5xl font-bold text-green-700" data-id="element-306">
                      $7.97
                    </span>
                    <span className="text-gray-500 text-lg" data-id="element-307">USD</span>
                  </div>
                  <p className="text-sm text-green-600 font-medium" data-id="element-308">
                    ✨ Precio especial de lanzamiento
                  </p>
                </div>
                <div className="space-y-3 mb-8" data-id="element-309">
                  <div className="flex items-start gap-3" data-id="element-310">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-311" />
                    <span className="text-gray-700" data-id="element-312">
                      Descarga inmediata en PDF
                    </span>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-313">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-314" />
                    <span className="text-gray-700" data-id="element-315">
                      Plantillas listas para imprimir
                    </span>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-316">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-317" />
                    <span className="text-gray-700" data-id="element-318">
                      Método paso a paso adaptado a LATAM
                    </span>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-319">
                    <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-320" />
                    <span className="text-gray-700" data-id="element-321">Acceso de por vida</span>
                  </div>
                </div>
                <button onClick={handleAddToCart} className="w-full bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 px-6 rounded-lg text-lg shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-322">
                  <DownloadIcon className="w-5 h-5" data-id="element-323" />
                  Obtener mi guía ahora
                </button>
                <p className="text-center text-sm text-gray-500 mt-4" data-id="element-324">
                  🔒 Pago seguro • Descarga instantánea
                </p>
              </div>
            </div>
          </div>
          {/* Free Bonus Section #1 */}
          <div className="mt-6 max-w-4xl mx-auto" data-id="element-325">
            <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-2 border-amber-300 rounded-2xl overflow-hidden shadow-xl" data-id="element-326">
              <div className="bg-gradient-to-r from-amber-500 to-amber-600 py-3 px-6" data-id="element-327">
                <div className="flex items-center justify-center gap-2" data-id="element-328">
                  <GiftIcon className="w-6 h-6 text-white" data-id="element-329" />
                  <h3 className="text-xl md:text-2xl font-bold text-white text-center" data-id="element-330">
                    BONOS GRATIS INCLUIDOS
                  </h3>
                  <GiftIcon className="w-6 h-6 text-white" data-id="element-331" />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6 p-8" data-id="element-332">
                {/* Bonus Image */}
                <div className="flex items-center justify-center" data-id="element-333">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sgrL3ziu8Hs2teLBcYaiY7/Mockup_Bono2.png" alt="Guía de 30 Fugas Invisibles" className="w-full max-w-sm rounded-lg shadow-lg" data-id="element-334" />
                </div>
                {/* Bonus Details */}
                <div className="flex flex-col justify-center" data-id="element-335">
                  <h4 className="text-2xl font-bold text-amber-800 mb-3" data-id="element-336">
                    🎁 BONO #1
                  </h4>
                  <h5 className="text-xl font-bold text-gray-900 mb-4" data-id="element-337">
                    "Guía de 30 Fugas Invisibles que te Roban la Quincena"
                  </h5>
                  <p className="text-gray-700 mb-4" data-id="element-338">
                    La lupa que toda mujer necesita para descubrir en qué se
                    está yendo su quincena sin darse cuenta.
                  </p>
                  <div className="space-y-3 mb-4" data-id="element-339">
                    <div className="flex items-start gap-2" data-id="element-340">
                      <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-341" />
                      <span className="text-sm text-gray-700" data-id="element-342">
                        Identifica 30 fugas invisibles reales de la vida en
                        LATAM
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-343">
                      <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-344" />
                      <span className="text-sm text-gray-700" data-id="element-345">
                        Distingue entre gasto hormiga y gustito consciente
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-346">
                      <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-347" />
                      <span className="text-sm text-gray-700" data-id="element-348">
                        Detecta hábitos que multiplican tus deudas
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-349">
                      <CheckCircleIcon className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-350" />
                      <span className="text-sm text-gray-700" data-id="element-351">
                        Plan 7 días "Quita Fugas" para recuperar dinero
                      </span>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border-2 border-amber-200" data-id="element-352">
                    <p className="text-center font-bold text-amber-700" data-id="element-353">
                      ¡GRATIS con tu compra hoy!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Free Bonus Section #2 */}
          <div className="mt-4 max-w-4xl mx-auto" data-id="element-354">
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-2xl overflow-hidden shadow-xl" data-id="element-355">
              <div className="bg-gradient-to-r from-green-600 to-green-700 py-3 px-6" data-id="element-356">
                <div className="flex items-center justify-center gap-2" data-id="element-357">
                  <GiftIcon className="w-6 h-6 text-white" data-id="element-358" />
                  <h3 className="text-xl md:text-2xl font-bold text-white text-center" data-id="element-359">
                    BONO ADICIONAL GRATIS
                  </h3>
                  <GiftIcon className="w-6 h-6 text-white" data-id="element-360" />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6 p-8" data-id="element-361">
                {/* Bonus Image */}
                <div className="flex items-center justify-center" data-id="element-362">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eUBt8WrzqELqVBp3p46p4D/Mockup_Bono2.png" alt="Sobre Extra: Fondo Por Si Las Dudas" className="w-full max-w-sm rounded-lg shadow-lg" data-id="element-363" />
                </div>
                {/* Bonus Details */}
                <div className="flex flex-col justify-center" data-id="element-364">
                  <h4 className="text-2xl font-bold text-green-800 mb-3" data-id="element-365">
                    🎁 BONO #2
                  </h4>
                  <h5 className="text-xl font-bold text-gray-900 mb-4" data-id="element-366">
                    "Sobre Extra: Fondo 'Por Si Las Dudas'"
                  </h5>
                  <p className="text-gray-700 mb-4" data-id="element-367">
                    El sobre más importante de todo tu sistema: un fondo
                    exclusivo para emergencias reales que te salva la quincena
                    sin volver a pedir prestado.
                  </p>
                  <div className="space-y-3 mb-4" data-id="element-368">
                    <div className="flex items-start gap-2" data-id="element-369">
                      <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-370" />
                      <span className="text-sm text-gray-700" data-id="element-371">
                        Distingue entre antojo, urgencia emocional y verdadera
                        emergencia
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-372">
                      <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-373" />
                      <span className="text-sm text-gray-700" data-id="element-374">
                        Define cuánto deberías tener según tu realidad (básico,
                        intermedio, pro)
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-375">
                      <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-376" />
                      <span className="text-sm text-gray-700" data-id="element-377">
                        Alimenta tu fondo quincena a quincena con
                        micro-aportaciones
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-378">
                      <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-379" />
                      <span className="text-sm text-gray-700" data-id="element-380">
                        Checklist claro: cuándo SÍ y cuándo NO tocarlo
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-381">
                      <CheckCircleIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-382" />
                      <span className="text-sm text-gray-700" data-id="element-383">
                        Plan de reconstrucción después de usarlo, sin culpa
                      </span>
                    </div>
                  </div>
                  <div className="bg-white rounded-lg p-4 border-2 border-green-200" data-id="element-384">
                    <p className="text-center font-bold text-green-700" data-id="element-385">
                      ¡También GRATIS con tu compra hoy! 💚
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center max-w-2xl mx-auto" data-id="element-386">
            <p className="text-lg text-gray-700 mb-4" data-id="element-387">
              <strong className="text-green-700" data-id="element-388">
                Inversión de menos de $8
              </strong>{' '}
              para cambiar tu relación con el dinero para siempre.
            </p>
            <p className="text-gray-600" data-id="element-389">
              Lo que gastas en un café… puede ser el primer paso hacia tu
              libertad financiera.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="w-full py-8 bg-green-700 text-white" data-id="element-390">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-391">
          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-392">
            El cambio comienza ahora
          </h2>
          <p className="text-lg mb-8" data-id="element-393">
            No importa cómo llegaste hoy. Lo que importa es cómo quieres llegar
            a la próxima quincena.
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-4 mb-8 text-center" data-id="element-394">
            <div className="flex-1 bg-green-800 bg-opacity-50 p-4 rounded-lg" data-id="element-395">
              <p data-id="element-396">Con miedo…</p>
              <p className="text-green-300" data-id="element-397">o con control total.</p>
            </div>
            <div className="flex-1 bg-green-800 bg-opacity-50 p-4 rounded-lg" data-id="element-398">
              <p data-id="element-399">Sin dinero…</p>
              <p className="text-green-300" data-id="element-400">o con ahorro real.</p>
            </div>
            <div className="flex-1 bg-green-800 bg-opacity-50 p-4 rounded-lg" data-id="element-401">
              <p data-id="element-402">Con estrés…</p>
              <p className="text-green-300" data-id="element-403">o con tranquilidad.</p>
            </div>
          </div>
          <p className="text-lg mb-8" data-id="element-404">
            Este es tu momento. Tu punto de quiebre. Tu nueva historia
            financiera comienza aquí.
          </p>
          <CTAButton data-id="element-405" />
          <div className="mt-8 text-center" data-id="element-406">
            <p className="text-xl font-bold mb-2" data-id="element-407">
              De Quincena en Rojo a Quincena en Verde
            </p>
            <p className="text-lg" data-id="element-408">
              Tu método, tu sistema, tu nueva forma de vivir la quincena.
            </p>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="w-full py-6 bg-green-900 text-white text-center" data-id="element-409">
        <div className="max-w-4xl mx-auto px-4" data-id="element-410">
          <p className="text-sm text-green-200" data-id="element-411">
            © 2023 De Quincena en Rojo a Quincena en Verde. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}